import { Component, Input, OnInit, SimpleChange, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordStrengthComponent implements OnInit {

  bar0: any;
  bar1: any;
  bar2: any;
  bar3: any;
  PasswordOutputObject: any = {};
  // passwordIsValid: boolean;
  // passwordStrengthDescription: string;
  @Input() public passwordToCheck: string;
  @Input() public hasComplexPassword: boolean;
  //@Output() passwordStrength = new EventEmitter<boolean>();
  @Output() passwordStrengthObject = new EventEmitter<any>();
  private colors = ['red', 'red', 'orange', '#17c251'];
  constructor() { }

  ngOnInit(): void {
  }
  checkStrength(p: any) {
    // 1
    let force = 0;

    // 2
    const regex = /[!_.#$%&*@]/g;
    const lowerLetters = /[a-z]+/.test(p);
    const upperLetters = /[A-Z]+/.test(p);
    const numbers = /[0-9]+/.test(p);
    const symbols = regex.test(p);
    const hasInvalidChar = /[^a-zA-Z0-9!_.#$%&*@]/.test(p);

    if (hasInvalidChar) {
      return 0;
    }

    // 3
    const flags = [lowerLetters, upperLetters, numbers, symbols];

    // 4
    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    // 5
    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // 6
    force = (p.length <= 6) ? Math.min(force, 10) : force;

    // 7
    force = (passedMatches === 1) ? Math.min(force, 10) : force;
    force = (passedMatches === 2) ? Math.min(force, 20) : force;
    force = (passedMatches === 3) ? Math.min(force, 30) : force;
    force = (passedMatches === 4) ? Math.min(force, 40) : force;

    return force;
  }
  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck?.currentValue;
    this.setBarColors(4, '#DDD');
    if (password) {
      const c = this.getColor(this.checkStrength(password));
      this.setBarColors(c.index, c.color);
      const pwdStrength = this.checkStrength(password);
      // pwdStrength === 40 || pwdStrength === 30 ? this.passwordStrength.emit(true) : this.passwordStrength.emit(false);
      if (pwdStrength === 0) {
        this.PasswordOutputObject.passwordIsValid = false;
        this.PasswordOutputObject.passwordStrengthDescription = "Invalid";
        this.PasswordOutputObject.passwordStrengthLongDescription = "Password contains invalid special characters";
      }
      else if (pwdStrength === 40) {
        this.PasswordOutputObject.passwordIsValid = true;
        this.PasswordOutputObject.passwordStrengthDescription = "Strong";
        this.PasswordOutputObject.passwordStrengthLongDescription = "The password is strong enough";
      }
      else if (pwdStrength === 30) {
        this.PasswordOutputObject.passwordIsValid = false;
        this.PasswordOutputObject.passwordStrengthDescription = "Medium";
        this.PasswordOutputObject.passwordStrengthLongDescription = "The password isn't strong enough";
      }
      else {
        this.PasswordOutputObject.passwordIsValid = false;
        this.PasswordOutputObject.passwordStrengthDescription = "Weak";
        this.PasswordOutputObject.passwordStrengthLongDescription = "The password isn't strong enough";
      }
      this.PasswordOutputObject.color = c.color
      this.passwordStrengthObject.emit(this.PasswordOutputObject);
    }
    else {
      this.passwordStrengthObject.emit({});
    }

  }

  private getColor(s: any) {
    let index = 0;
    if (s === 0 || s === 10) {
      index = 0;
    } else if (s === 20) {
      index = 1;
    } else if (s === 30) {
      index = 2;
    } else if (s === 40) {
      index = 3;
    } else {
      index = 0;
    }
    return {
      index: index + 1,
      color: this.colors[index] || 'red'
    };
  }

  private setBarColors(count: any, col: any) {
    for (let n = 0; n < count; n++) {
      this['bar' + n as keyof BarKeyObject] = col;
      // this.bar0 = col;
      // this.bar1 = col;
      // this.bar2 = col;
      // this.bar3 = col;
    }
  }
}
interface BarKeyObject {
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string
}
